import { useState, useEffect, useContext } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import "../../../styles/panel/user/Sidebar.css";
import { AuthContext } from "../../../context/AuthContext";
import RegisterSiteForm from "./RegisterSiteForm";
import whiteLogoFull from "../../../assets/website/white-logo-full.svg";
import ChatWidget from "./ChatWidget";

// آیکن‌های SVG به صورت کامپوننت‌های کوچک
const Icon = ({ children }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

const ChevIcon = () => (
  <svg
    className="chev"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2.3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

// ساختار داده‌ی منو (برگرفته از فایل اصلی)
// id هر آیتم دقیقاً همون path ای هست که در panelRoutes.js تعریف شده
const NAV_DATA = [
  {
    type: "link",
    id: "dashboard",
    label: "داشبورد",
    icon: <path d="M3 12l9-8 9 8M6 10.5V20h12v-9.5" />,
  },
  {
    type: "link",
    id: "profile",
    label: "پروفایل",
    icon: (
      <>
        <circle cx="12" cy="8" r="3.4" />
        <path d="M5 20c0-3.6 3.1-6.5 7-6.5s7 2.9 7 6.5" />
      </>
    ),
  },
  { type: "section", label: "سایت‌ها" },
  {
    type: "toggle",
    id: "sites",
    label: "سایت‌ها و درخواست‌ها",
    icon: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c2.4 2.6 3.6 5.7 3.6 9s-1.2 6.4-3.6 9c-2.4-2.6-3.6-5.7-3.6-9s1.2-6.4 3.6-9z" />
      </>
    ),
    children: [
      { id: "sites-requests", label: "درخواست‌های سایت" },
      { id: "my-sites", label: "سایت‌های من" },
    ],
  },
  {
    type: "toggle",
    id: "shop",
    label: "فروشگاه",
    icon: (
      <>
        <path d="M3 9l1.5-5h15L21 9" />
        <path d="M4 9h16v10a1 1 0 01-1 1H5a1 1 0 01-1-1V9z" />
        <path d="M9 13a3 3 0 006 0" />
      </>
    ),
    children: [
      { id: "manage-shops", label: "مدیریت فروشگاه‌ها" },
      { id: "manage-orders", label: "مدیریت سفارش‌ها" },
      { id: "customers", label: "مشتریان" },
    ],
  },
  { type: "section", label: "مالی" },
  {
    type: "toggle",
    id: "finance",
    label: "درآمد و مالی",
    icon: (
      <>
        <rect x="3" y="7" width="18" height="12" rx="2" />
        <path d="M3 11h18" />
        <circle cx="8" cy="15" r="1.1" fill="currentColor" stroke="none" />
      </>
    ),
    children: [
      { id: "register-site", label: "ثبت سایت برای دیگران" },
      { id: "commission", label: "پورسانت من" },
      { id: "wallet", label: "کیف پول" },
      { id: "withdraw-requests", label: "درخواست‌های برداشت" },
      { id: "transactions", label: "تراکنش‌ها" },
    ],
  },
  { type: "section", label: "پشتیبانی" },
  {
    type: "toggle",
    id: "support",
    label: "پشتیبانی",
    icon: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 8v4l2.5 2.5" />
      </>
    ),
    children: [
      { id: "new-ticket", label: "تیکت جدید" },
      { id: "ticket-archive", label: "آرشیو تیکت‌ها" },
    ],
  },
  {
    type: "toggle",
    id: "chat",
    label: "چت آنلاین",
    icon: (
      <>
        <path d="M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22C17.5228 22 22 17.5228 22 12C22 10.1786 21.513 8.47087 20.6622 7" />
        <path d="M8 12H8.009M11.991 12H12M15.991 12H16" />
      </>
    ),
    children: [
      { id: "chat-archive", label: "آرشیو چت ها" },
      // { id: "chat", label: "چت" },
    ],
  },
  { type: "section", label: "پرومجازی" },
  {
    // لینک به پنل جداگانه‌ی پرومجازی (خارج از /panel/user)
    type: "link",
    id: "pro-majazi",
    to: "/panel/pro-majazi/dashboard",
    label: "پرومجازی",
    icon: (
      <>
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <path d="M8 20h8M12 16v4" />
        <path d="M9.5 10l1.8 1.8L14.5 8.5" />
      </>
    ),
  },
];

export default function Sidebar() {
  const { logout, user } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openToggles, setOpenToggles] = useState({});
  const location = useLocation();

  // مسیر فعلی به شکل /panel/<id> است، پس با آخرین بخش پث مقایسه می‌کنیم
  const currentId = location.pathname.split("/").filter(Boolean).pop();
  const isActive = (id) => currentId === id;

  // تشخیص حالت موبایل/تبلت (همان breakpoint فایل CSS: 1024px)
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 1024px)").matches
      : false,
  );
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1024px)");
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  // وقتی سایدبار در حالت موبایل باز است، اسکرول پشت صفحه قفل می‌شود
  useEffect(() => {
    document.body.classList.toggle("sidebar-locked", isMobile && mobileOpen);
    return () => document.body.classList.remove("sidebar-locked");
  }, [mobileOpen, isMobile]);

  // وقتی مسیر عوض شد (یعنی یک لینک انتخاب شد)، منوی موبایل بسته شود
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const toggleSection = (id) => {
    if (collapsed) {
      setCollapsed(false);
      setOpenToggles((prev) => ({ ...prev, [id]: true }));
      return;
    }
    setOpenToggles((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      {/* دکمه‌ی همبرگری/بازگشت - فقط در موبایل و تبلت نمایش داده می‌شود */}
      <button
        className={`mobile-topbar-toggle${mobileOpen ? " is-open" : ""}`}
        aria-label={mobileOpen ? "بستن منو" : "باز کردن منو"}
        aria-expanded={mobileOpen}
        onClick={() => setMobileOpen((v) => !v)}
      >
        <span className="toggle-icon-swap">
          <svg
            className="icon-menu"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 7h16M4 12h16M4 17h16" />
          </svg>
          <svg
            className="icon-back"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M11 6l-6 6 6 6" />
          </svg>
        </span>
      </button>

      {/* بک‌دراپ تیره پشت منو در حالت موبایل/تبلت */}
      {mobileOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <aside
        className={`sidebar${collapsed ? " collapsed" : ""}${
          mobileOpen ? " mobile-open" : ""
        }`}
        aria-hidden={isMobile && !mobileOpen ? "true" : undefined}
        inert={isMobile && !mobileOpen ? "" : undefined}
      >
        <div className="brand-row">
          <button
            className="brand-mark"
            aria-label={collapsed ? "باز کردن منو" : "جمع کردن منو"}
            onClick={() => setCollapsed((c) => !c)}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>
          <div className="brand-text">
            <div className="brand-name">پنل کاربر</div>
            <div className="brand-sub">دکانا بانک جامع فروشگاه های ایران</div>
          </div>
        </div>

        <nav className="nav-scroll">
          {NAV_DATA.map((item, i) => {
            if (item.type === "section") {
              return (
                <div key={`section-${i}`}>
                  <div className="section-gap" />
                  <div className="section-label">{item.label}</div>
                </div>
              );
            }

            if (item.type === "section-gap") {
              return <div className="section-gap" key={`gap-${i}`} />;
            }

            if (item.type === "link") {
              const active = isActive(item.id);
              return (
                <div className="nav-item" key={item.id}>
                  <Link
                    to={item.to || `/panel/user/${item.id}`}
                    className={`nav-link${active ? " active" : ""}`}
                  >
                    <Icon>{item.icon}</Icon>
                    <span className="label">{item.label}</span>
                  </Link>
                  <div className="tooltip">{item.label}</div>
                </div>
              );
            }

            if (item.type === "toggle") {
              const isOpen = !!openToggles[item.id];
              const hasActiveChild = item.children.some((c) => isActive(c.id));
              return (
                <div className="nav-item" key={item.id}>
                  <button
                    className={`nav-toggle${hasActiveChild ? " active" : ""}`}
                    aria-expanded={isOpen}
                    onClick={() => toggleSection(item.id)}
                  >
                    <Icon>{item.icon}</Icon>
                    <span className="label">{item.label}</span>
                    <ChevIcon />
                  </button>
                  <div className="tooltip">{item.label}</div>
                  <div
                    className="submenu"
                    style={{ maxHeight: isOpen ? "280px" : "0px" }}
                  >
                    <div className="submenu-inner">
                      {item.children.map((child) => (
                        <Link
                          key={child.id}
                          to={`/panel/user/${child.id}`}
                          className={`sub-link${isActive(child.id) ? " active" : ""}`}
                        >
                          {child.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              );
            }

            return null;
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="user-card">
            <div className="user-avatar">
              <a href="/">
                <img src={whiteLogoFull}></img>
              </a>
            </div>
            <div className="user-meta">
              <div className="user-name">
                {user?.first_name} {user?.last_name}
              </div>
              {/* <div className="user-role">فروشنده طلایی</div> */}
            </div>
            <button
              className="logout-btn"
              type="button"
              aria-label="خروج از حساب کاربری"
              onClick={logout}
            >
              <svg
                width="800px"
                height="800px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2 6.5C2 4.01472 4.01472 2 6.5 2H12C14.2091 2 16 3.79086 16 6V7C16 7.55228 15.5523 8 15 8C14.4477 8 14 7.55228 14 7V6C14 4.89543 13.1046 4 12 4H6.5C5.11929 4 4 5.11929 4 6.5V17.5C4 18.8807 5.11929 20 6.5 20H12C13.1046 20 14 19.1046 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 20.2091 14.2091 22 12 22H6.5C4.01472 22 2 19.9853 2 17.5V6.5ZM18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071C17.9024 15.3166 17.9024 14.6834 18.2929 14.2929L19.5858 13L11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11L19.5858 11L18.2929 9.70711C17.9024 9.31658 17.9024 8.68342 18.2929 8.29289Z"
                  fill="#0F1729"
                />
              </svg>
            </button>
          </div>
        </div>
      </aside>

      <main className="content">
        {/* صفحه‌ی فعال بر اساس URL اینجا رندر می‌شود (تعریف‌شده در panelRoutes.js) */}
        <Outlet />
      </main>

      {/* آیکن شناور چت — گوشه‌ی پایین-چپ صفحه؛ با کلیک، چت به‌صورت پاپ‌آپ باز می‌شود */}
      <ChatWidget />
    </>
  );
}
